module.exports = __webpack_public_path__ + "img/profile-view.6e14156a.png";